import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaSuperplastPQC = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Superplast - PQC"
        subTitle="(High Performance Superplasticizer For Pavement Quality Concrete)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista Superplast - PQC"
          title="Description"
          imageUrl={imgnotavailableImg}
          content="Vista Superplast PQC is a Latest Technology high-performance Superplasticiser for Pavement Quality Concrete based on Modified poly carboxylate ether suitable for concreting in hot climates confirming to IS 9103: 1999; ASTM C494."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista Superplast PQC is recommended for use in Ready Mix Concrete for Highway/Roads, Airport Runways, Apron, Bridge Decks etc." />
          <CustomLists
            items={[
              [
                "To produce high strength, high-grade concrete M40 and above.",
                "To produce high workability concrete requiring little or no vibration during placing.",
                "To produce pumpable concrete.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Provides significant increase in Early strength",
                "Permeability of the concrete is reduced.",
                "Denser, close-textured concrete with reduced porosity and hence more durable.",
              ],
              [
                "Improved workability - easier, quicker placing and compaction.",
                "Reduced risk of segregation and bleeding.",
                "No Shrinkage effect.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Brown Liquid"],
                ["Specific Gravity", "1.08 +/- 0.02"],
                ["Chloride Content", "NIL(As Per BS 5075)"],
                ["pH", "> 6"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Precaution">
          <Paragraph content="Vista Superplast PQC is non-toxic, non-flammable, Ecofriendly, and harmless. Any splashes on the skin should be washed immediately with water." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSuperplastPQC;
